export const EPrinterStatus = {
    NORMAL: {
        key: 'NORMAL',
        value: '正常',
    }, //  正常
    ERROR: {
        key: 'ERROR',
        value: '错误',
    }, //  正常
    OFFLINE: {
        key: 'OFFLINE',
        value: '脱机（仅驱动打印机会返回）',
    }, //  正常
    SUSPENDED: {
        key: 'SUSPENDED',
        value: '暂停（仅驱动打印机会返回）',
    }, //  正常
    OPEN_LID: {
        key: 'OPEN_LID',
        value: '开盖（仅免驱打印机会返回）',
    }, //  正常
    SHORT_PAPER: {
        key: 'SHORT_PAPER',
        value: ' 缺纸（仅免驱打印机会返回）',
    }, //  正常
    SHORT_PAPER_OPEN_LID: {
        key: 'SHORT_PAPER_OPEN_LID',
        value: '缺纸&开盖（仅免驱打印机会返回）',
    }, //  正常
};

/**
 * PCS_CODE（件码）、BULK_WEIGHT_CODE(24散称码)、FRESH_PIECE_CODE(27生鲜码)、NORMAL_CODE(69标准码)、DATE_CODE(26日期码)、UNKNOWN_CODE(未知码类型)
 */
export const CODE_TYPE = {
    PCS_CODE: 'PCS_CODE',
    BULK_WEIGHT_CODE: 'BULK_WEIGHT_CODE',
    FRESH_PIECE_CODE: 'FRESH_PIECE_CODE',
    NORMAL_CODE: 'NORMAL_CODE',
    DATE_CODE: 'DATE_CODE',
    UNKNOWN_CODE: 'UNKNOWN_CODE',
};

/**
 * 效期类型枚举
 */
export const ExpirationTypeEnum = {
    HALF_DAY: {
        code: 1,
        desc: '半天效期',
        tagId: 100740,
    },
    HOUR: {
        code: 2,
        desc: '小时批次',
        tagId: 100743,
    },
    QUARTER_DAY: {
        code: 3,
        desc: '1/4天批次',
        tagId: 100742,
    },
    ONE_THIRD_DAY: {
        code: 4,
        desc: '1/3天批次',
        tagId: 100741,
    },
    DEFAULT: {
        code: 0,
        desc: '默认',
        tagId: 0,
    },
};
